import React from "react";

import { LockOutlined } from "@mui/icons-material";
import { Avatar, Box, Container } from "@mui/material";

import { Copyright } from "client/components";
import { AuthResponseStatusEnum } from "client/services/auth/enums/auth-response-status.enum";

import { ConfirmPasswordForm, LoginForm } from "./components";
import TwoFactorForm from "./components/TwoFactorForm/TwoFactorForm";
import { useLogin } from "./hooks/useLogin";

export const Login = (): React.ReactElement => {
  const { loading, status, login, tempAuth } = useLogin();
  console.log("Test CI/CD");

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlined />
        </Avatar>

        {(!status || status === AuthResponseStatusEnum.Ok) && (
          <LoginForm loading={loading} onLoginSubmit={login} />
        )}

        {status === AuthResponseStatusEnum.NewPasswordRequired && (
          <ConfirmPasswordForm
            loading={loading}
            tempAuth={tempAuth}
            onConfirmSubmit={login}
          />
        )}
        {status === AuthResponseStatusEnum.MfaCodeSent && <TwoFactorForm />}
      </Box>
      <Copyright />
    </Container>
  );
};

export default Login;
